(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
    const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        observer.unobserve(productRecommendationsSection);

        const url = productRecommendationsSection.dataset.url;

        fetch(url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    productRecommendationsSection.innerHTML = recommendations.innerHTML;
                }
            })
            .catch((e) => {
                console.error(e);
            });
    };

    const productRecommendationsSection = document.querySelector('.product-recommendations');
    const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

    observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !Shopify.designMode) return;
  try {
    
    // liberated from js/app/tabs.js
    class Tabs {
        constructor(el) {
            this.tabs = Array.from(el.querySelectorAll('[role="tab"]'));
            this.firstTab = null;
            this.lastTab = null;
            this.tabPanels = [];

            this.tabs.forEach((tab) => {
                let controlsId = tab.getAttribute('aria-controls');
                this.tabPanels.push(document.getElementById(controlsId));

                tab.addEventListener('keydown', this.onKeydown.bind(this));
                tab.addEventListener('click', this.onClick.bind(this));

                if (!this.firstTab) {
                    this.firstTab = tab;
                }
                this.lastTab = tab;
            });
        }

        setSelectedTab(currentTab) {
            this.tabs.forEach((tab, index) => {
                if (currentTab === tab) {
                    tab.setAttribute('aria-selected', true);
                    tab.removeAttribute('tabindex');
                    this.tabPanels[index].classList.add('active');
                    tab.focus();
                    if (window.outerWidth < window.app.breakpoints.lg) {
                        this.tabPanels[index].scrollIntoView();
                    }
                } else {
                    tab.setAttribute('aria-selected', false);
                    tab.tabIndex = -1;
                    this.tabPanels[index].classList.remove('active');
                }
            });
        }

        setSelectedToNextTab(currentTab) {
            if (currentTab === this.lastTab) {
                this.setSelectedTab(this.firstTab);
                return;
            }

            let index = this.tabs.indexOf(currentTab);
            this.setSelectedTab(this.tabs[index + 1]);
        }

        setSelectedToPreviousTab(currentTab) {
            if (currentTab === this.firstTab) {
                this.setSelectedTab(this.lastTab);
                return;
            }

            let index = this.tabs.indexOf(currentTab);
            this.setSelectedTab(this.tabs[index - 1]);
        }

        onClick(event) {
            event.preventDefault();
            this.setSelectedTab(event.currentTarget);
        }

        onKeydown(event) {
            let target = event.currentTarget;
            let flag = false;

            switch (event.key) {
                case 'ArrowLeft':
                    this.setSelectedToPreviousTab(target);
                    flag = true;
                    break;

                case 'ArrowRight':
                    this.setSelectedToNextTab(target);
                    flag = true;
                    break;

                default:
                    break;
            }
            if (flag) {
                event.stopPropagation();
                event.preventDefault();
            }
        }
    }
    // shopify doesn't let us loop over theme blocks, so we need to build the nav with js
    const tabs = document.querySelectorAll('.tabs');
    tabs.forEach((el) => {
        const tabList = el.querySelector('.nav');
        const tabPanels = el.querySelectorAll('.panels .tab-content');
        if (tabPanels) {
            if (!tabList.querySelector('.nav-item')) {
                tabPanels.forEach((panel, index) => {
                    const button = document.createElement('button');
                    button.classList.add('nav-item');
                    button.setAttribute('role', 'tab');
                    button.setAttribute('tabindex', index === 0 ? '0' : '-1');
                    button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
                    button.setAttribute('aria-controls', panel.getAttribute('id'));
                    button.setAttribute('id', 'tab-' + panel.getAttribute('id'));
                    button.textContent = panel.dataset.title;
                    tabList.appendChild(button);
                });
                tabList.setAttribute('role', 'tablist');
            }
            tabPanels[0].classList.add('active');
        }
        new Tabs(el);
    });

  } catch(e) { console.error(e); }
})();
})();
